import segment from 'src/js/modules/analytics/segment';

const {
  constants,
  trackers: { trackEvent },
} = segment;

const trackElementSettingsTabChanged = ({
  blockId,
  blockVariationId,
  settingsId,
  tabId,
  elementType,
}) => {
  if (!blockId) return;

  trackEvent(constants.events.ELEMENT_SETTINGS_TAB_CHANGED, {
    blockId,
    blockVariationId,
    settingsId,
    tabId,
    elementId: elementType,
  });
};

export default trackElementSettingsTabChanged;
